import React from 'react';
import moment from 'moment';
import { ApIcon } from '@alixpartners/ui-components';
import { brandColors } from 'styles/colors';

import { LatestUpdateSection, IconWrapper, MessageWrapper } from './styles';

const DEFAULT_MESSAGE =
	'Please upload the Unclassified Raw Client Data CSV to start.';

const LatestUpdateAlert = props => {
	const { user, date, type } = props;
	const formattedDate = moment.utc(date, moment.ISO_8601);
	const typeMsg = type ? 'Spendcube' : 'Raw Client Data';
	const message = `${typeMsg} was last uploaded by: ${user}, ${formattedDate
		.local()
		.format('MMMM Do, h:mm a')}`;

	return (
		<LatestUpdateSection
			className={props.className}
			onClick={e => e.stopPropagation()}
		>
			<IconWrapper>
				<ApIcon
					iconName="outline_error"
					iconSize="24px"
					iconColor={brandColors.green}
				/>
			</IconWrapper>
			<MessageWrapper>
				{user && date ? message : DEFAULT_MESSAGE}
			</MessageWrapper>
		</LatestUpdateSection>
	);
};

export default LatestUpdateAlert;
